import { useCallback } from 'react';
import { invariant } from 'ts-invariant';
import type { OnActionType } from '../../../../context/ActionsProvider/context';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';
import useControlBlockMethod from '../controlBlockMethod/useControlBlockMethod';

type BottomSheetActionPayload = {
  bottomSheetId?: string;
  operation: 'show' | 'hide';
};

function useControlBottomSheetActions() {
  const { onCallBlockMethod } = useControlBlockMethod();
  const onControlBottomSheet: OnActionType = useCallback(
    async ({ action, actionContext, instanceId }) => {
      const payload = action.payload as BottomSheetActionPayload;
      const blockId = payload.bottomSheetId;
      invariant(blockId, 'BottomSheet id is required');

      switch (payload.operation) {
        case 'show':
          await onCallBlockMethod({
            blockId,
            methodName: 'showDrawer',
            action,
            actionContext,
            instanceId,
          });
          break;
        case 'hide':
          await onCallBlockMethod({
            blockId,
            methodName: 'hideDrawer',
            action,
            actionContext,
            instanceId,
          });
          break;
        default:
          break;
      }
      return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
    },
    [onCallBlockMethod],
  );

  return { onControlBottomSheet };
}

export default useControlBottomSheetActions;
